import { create } from "zustand";

import { IMenuDetails, IPopoverMenuStore } from "./usePopoverMenuStore.types";
import { INITIAL_STATE } from "./usePopoverMenuStore.constants";

export const usePopoverMenuStore = create<IPopoverMenuStore>()((set, get) => ({
  state: INITIAL_STATE.state,
  setState: (state) => set(() => ({ state })),
  title: INITIAL_STATE.title,
  setTitle: (title) => set(() => ({ title })),
  items: INITIAL_STATE.items,
  setItems: (items) => set(() => ({ items })),
  openMenuEvent: INITIAL_STATE.openMenuEvent,
  closeMenuEvent: INITIAL_STATE.closeMenuEvent,
  setMenuDetails: (menuDetails: IMenuDetails) => set(() => ({ ...menuDetails })),
  getMenuDetails: () => ({
    state: get().state,
    title: get().title,
    items: get().items,
    openMenuEvent: get().openMenuEvent,
    closeMenuEvent: get().closeMenuEvent,
  }),
  resetMenuDetails: (delay = 0) => {
    get().setState(INITIAL_STATE.state);
    setTimeout(() => {
      set(() => ({
        title: INITIAL_STATE.title,
        items: INITIAL_STATE.items,
        openMenuEvent: INITIAL_STATE.openMenuEvent,
        closeMenuEvent: INITIAL_STATE.closeMenuEvent,
      }));
    }, delay);
  },
}));

export default usePopoverMenuStore;
